import React from 'react';

import { IIconProps } from '@icons/IIconProps';
import { UsdCircleIcon } from '@icons/index';

const UsdFilledIcon = (props: IIconProps) => {
    return <UsdCircleIcon style={{ color: 'var(--main-green)', fontSize: 28, ...props.style}} />;
};

export default UsdFilledIcon;
